import { z } from "zod";

// ===== Single Blog Item ===========================================
export const schemaBlogItem = z.object({
    status: z.string(),
    statuscode: z.number(),
    result: z.object({
        id: z.string().max(36).min(36),
        url: z.string(),
        title: z.string(),
        intro: z.string(),
        seo: z.string(),
        imageurl: z.string(),
        date: z.string(),
        copy: z.string(),
    })
});

export type BlogItem = z.infer<typeof schemaBlogItem>;
// ...existing code...

// ===== Blogs ===========================================
export const schemaBlogs = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(
        z.object({
            id: z.string().max(36).min(36),
            url: z.string(),
            title: z.string(),
            intro: z.string(),
            seo: z.string(),
            imageurl: z.string(),
            date: z.string(),
        }))
})

export type Blogs = z.infer<typeof schemaBlogs>


// ===== Product (linked to showcase item) ==========================
export const schemaShowcaseProduct = z.object({
    productid: z.string(),
    name: z.string(),
    image: z.string(),
    description: z.string(),
    posid: z.string(),
});


export type ShowcaseProduct = z.infer<typeof schemaShowcaseProduct>;

// ===== Showcase Category ============================
export const schemaShowcaseCategory = z.object({
    categoryid: z.string(),
    categoryname: z.string(),
    categoryimageurl: z.string(),
    categorylevel: z.string(),
    categorytag: z.string(),
});

export const schemaShowcaseCategoryList = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaShowcaseCategory),
});

export type ShowcaseCategory = z.infer<typeof schemaShowcaseCategory>;
export type ShowcaseCategoryList = z.infer<typeof schemaShowcaseCategoryList>;

// ===== end of showcase category ============================
export const schemaShowcaseCategoryLevel1 = z.object({
    categoryid: z.string(),
    categoryname: z.string(),
    categoryimageurl: z.string(),
    categorylevel: z.string(),
    categorytag: z.string(),
    showcasename: z.string().optional(),
});

export const schemaShowcaseCategoryLevel1List = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaShowcaseCategoryLevel1),
});

export type ShowcaseCategoryLevel1 = z.infer<typeof schemaShowcaseCategoryLevel1>;
export type ShowcaseCategoryLevel1List = z.infer<typeof schemaShowcaseCategoryLevel1List>;


// ===== Showcase (webshowcase) ============================
export const schemaShowcase = z.object({
    showcaseid: z.string(),
    showcasename: z.string(),
    showcaseimageurl: z.string(),
    showcaseitemname: z.string(),
    showcasecategoryname: z.string(),
    showcasecategorytag: z.string(),

});

export const schemaShowcaseList = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaShowcase),
});
export type Showcase = z.infer<typeof schemaShowcase>;
export type ShowCaseList = z.infer<typeof schemaShowcaseList>;
// ===== end of showcase ============================

// ===== Showcase Item ===================================

export const schemaShowcaseItemFlat = z.object({
    showcaseid: z.string(),
    showcasename: z.string(),
    showcaseimageurl: z.string(),
    showcaseitemname: z.string(),
    showcaseitemdefaultdescription: z.string(),
    showcaseitemfiltertag: z.string(),
    productname: z.string(),
    productimage: z.string(),
    producthtmldescription: z.string(),
    productid: z.string(),
});

export const schemaShowcaseItemList = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaShowcaseItemFlat),
});


export type ShowcaseItem = z.infer<typeof schemaShowcaseItemFlat>;
export type ShowCaseItemList = z.infer<typeof schemaShowcaseItemList>;


// ========== showcase item with nested product and attributes ==========
export const schemaShowcaseItemAttributeFlat = z.object({
    showcaseitemname: z.string(),
    productattributename: z.string(),
    productattributeimageurl: z.string(),
    productattributeisprimary: z.string(),
});
export const schemaShowcaseItemAttributeList = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaShowcaseItemAttributeFlat),
});

export type ShowcaseItemAttribute = z.infer<typeof schemaShowcaseItemAttributeFlat>;
export type ShowcaseItemAttributeList = z.infer<typeof schemaShowcaseItemAttributeList>;

// ===== Ad ============
export const schemaAd = z.object({
    id: z.string(),
    adname: z.string(),
    adredirecturl: z.string(),
    adimageurl: z.string(),
    adimagealttext: z.string(),
    adtitle: z.string(),
    adhtmldescription: z.string(),
    adexpirationdate: z.string(),
    adreleasedate: z.string(),
    adpublishingstate: z.string(),
});


export const schemaAdList = z.object({
    status: z.string(),
    statuscode: z.number(),
    results: z.array(schemaAd),
});
export type Ad = z.infer<typeof schemaAd>;
export type AdList = z.infer<typeof schemaAdList>;


// ===== Navigation ============================================
// Use NavigationLink and NavigationMenu from central models/navigation.ts
// Remove local navigation types and schemas. Import and use from models/navigation instead.
// ===== Web Pages from Dynamics CMS  ============================================
const schemaPageContent = z.object({
    status: z.string(),
    statuscode: z.number(),
    result: z.object(
        { id: z.string(), name: z.string(), content: z.string() }
    )
})


type PageContent = z.infer<typeof schemaPageContent>

export type { PageContent }
